import { render, staticRenderFns } from "./BannerViewedByPeriod.vue?vue&type=template&id=c3ae1fc0&"
import script from "./BannerViewedByPeriod.vue?vue&type=script&lang=js&"
export * from "./BannerViewedByPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports